import Parallax from 'parallax-js';

if (document.querySelector('[data-parallax-el]') && window.innerWidth >= 1025) {
  const parallaxContainer = document.querySelectorAll('[data-parallax-el]');
  parallaxContainer.forEach((elem) => {
    let parallaxInstance = new Parallax(elem);
    parallaxInstance.enable();
  });
}

if (document.getElementsByClassName('aura-card') && window.innerWidth > 551) {
  const page = document.querySelector('#site');
  const header = document.querySelector('header');
  const headerBurger = document.querySelector('.header .burger');
  const auraContainers = document.querySelectorAll('.aura-container');

  if (window.innerWidth > 1025) {
    auraContainers.forEach((container) => {
      const auraCursor = container.querySelector('.cursor-aura');
      const auraCursorWidth = auraCursor.offsetWidth;
      const auraCursorHeight = auraCursor.offsetHeight;

      const initLeft = parseFloat(getComputedStyle(auraCursor).left);
      const initTop = parseFloat(getComputedStyle(auraCursor).top);

      function cursorAuraLogic(e) {
        auraCursor.classList.add('active');
        const rect = container.getBoundingClientRect();
        let x = e.clientX - rect.left - auraCursorWidth / 1.85;
        let y = e.clientY - rect.top - auraCursorHeight / 1.95;

        const currentLeft = parseFloat(getComputedStyle(auraCursor).left);
        const currentTop = parseFloat(getComputedStyle(auraCursor).top);

        x -= currentLeft;
        y -= currentTop;

        requestAnimationFrame(() => {
          auraCursor.style.left = `${initLeft}px`;
          auraCursor.style.top = `${initTop}px`;

          auraCursor.style.transform = `translate(${x}px, ${y}px)`;
        });
      }

      function cursorAuraLeaveLogic() {
        auraCursor.classList.remove('active');
        auraCursor.style.left = `${initLeft}px`;
        auraCursor.style.top = `${initTop}px`;
        auraCursor.style.transform = `translate(-50%, -50%)`;
      }

      container.addEventListener('mousemove', (e) => {
        auraCursor.classList.add('is-init');
        cursorAuraLogic(e);
      });

      container.addEventListener('mouseleave', (event) => {
        const nextElement = document.elementFromPoint(
          event.clientX,
          event.clientY
        );

        if (header) {
          if (header.contains(nextElement)) {
            return;
          }
        }
        cursorAuraLeaveLogic();
      });

      if (header) {
        header.addEventListener('mousemove', (e) => {
          if (!header.classList.contains('open-menu')) {
            auraCursor.classList.add('is-init');
            cursorAuraLogic(e);
          }
        });

        header.addEventListener('mouseleave', (event) => {
          const nextElement = document.elementFromPoint(
            event.clientX,
            event.clientY
          );

          console.log(nextElement);

          if (container.contains(nextElement)) {
            console.log(123);
            return;
          }
          cursorAuraLeaveLogic();
        });

        headerBurger.addEventListener('click', () => {
          cursorAuraLeaveLogic();
        });
      }

      /*window.addEventListener('DOMContentLoaded', (event) => {
        const isCursorOverElement = isCursorOverElementOnLoad(container);
        console.log(
          'Курсор на элементе при загрузке страницы:',
          isCursorOverElement
        );
        cursorAuraLogic(event);
      });*/
    });

    /*function isCursorOverElementOnLoad(element) {
      const rect = element.getBoundingClientRect();
      const mouseX = window.pageXOffset + rect.left;
      const mouseY = window.pageYOffset + rect.top;
      console.log(mouseX);
      console.log(mouseY);
      return (
        mouseX >= 0 &&
        mouseX <= window.innerWidth &&
        mouseY >= 0 &&
        mouseY <= window.innerHeight
      );
    }*/
  }
}
